export default __webpack_public_path__ + "e8f9e356b0ecf5812c2456ad1ca0fe72.png";